import { render, staticRenderFns } from "./salaryList.vue?vue&type=template&id=2c78e60a&scoped=true"
import script from "./salaryList.vue?vue&type=script&lang=js"
export * from "./salaryList.vue?vue&type=script&lang=js"
import style0 from "./salaryList.vue?vue&type=style&index=0&id=2c78e60a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c78e60a",
  null
  
)

export default component.exports